import {useQuery} from "@tanstack/react-query";
import {useClientV2} from "../../../../utils/hooks";
import {AxiosError} from "axios";
import {GetStoreServicePortfolioImagesApiResponse} from "./types";
import {GET_STORE_SERVICE_PORTFOLIO_IMAGES_RQ_KEY} from "../constants";

/**
 * Hook for fetching store service portfolio images
 * Kept here as it's a query hook (not in new media module)
 */
export const useGetStoreServicePortfolioImages = (serviceId?: number) => {
  const client = useClientV2();

  return useQuery<
    GetStoreServicePortfolioImagesApiResponse,
    AxiosError<{status: boolean; message: string}>
  >({
    queryKey: [GET_STORE_SERVICE_PORTFOLIO_IMAGES_RQ_KEY, {serviceId: String(serviceId)}],
    queryFn: () =>
      client(`uploads/product-service/portfolio-image/${serviceId}`).then(
        (data) => data.data
      ),
    staleTime: Infinity,
    enabled: !!serviceId,
  });
};

/**
 * STRANGLER PATTERN: Re-exported from the new media feature module.
 * @deprecated Import from '@/features/media' instead
 */
export {
  useStoreServiceUploadCoverImages,
  useStoreServiceCoverImagesDelete,
  useStoreServiceUploadPortfolioImages,
  useStoreServicePortfolioImagesDelete,
} from "../../../../features/media";
